import e from "../../utils/classNames.js";
import t from "../button/Button.js";
import n from "../smoothScrollbars/SmoothScrollbars.js";
import r from "./ApplicationLayoutContext.js";
import i, { forwardRef as a, useContext as o, useEffect as s, useImperativeHandle as c, useRef as l, useState as u } from "react";
import { debounce as d } from "es-toolkit/compat";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
//#region src/components/applicationLayout/ApplicationLayoutBody.tsx
var m = 200, h = 54, g = a((a, g) => {
	let { className: _, innerClassName: v, forceScrollbar: y = !0, enableScrollToTop: b = !0, banner: x, navigation: S, bottomBar: C, bottomBarHeight: w = h, scrollResetTrigger: T, children: E, ...D } = a, [O, k] = u(0), A = o(r), j = l(null), M = l(null);
	c(g, () => M?.current, []), s(() => {
		j.current && (j.current.scrollTop(0), k(0));
	}, [T]), s(() => {
		M.current?.parentNode instanceof HTMLElement && (C ? M.current.parentNode.style.setProperty("--ApplicationLayoutBodyBottomBarHeight", `${w}px`) : M.current.parentNode.style.removeProperty("--ApplicationLayoutBodyBottomBarHeight"));
	}, [C, w]);
	let N = d(() => {
		j.current && k(j.current.getScrollTop());
	}, m), P = () => {
		if (!j.current) return;
		let e = j.current.container, t = e.firstElementChild, n = t?.scrollTop ?? 0;
		n > 10 ? (window.requestAnimationFrame(P), t?.scrollTo(0, n - n / 5), e.classList.add("is-scrolling-to-top"), k(n)) : e.classList.remove("is-scrolling-to-top");
	}, F = e("ApplicationLayoutBody", C ? "has-footer" : "", _), I = e("module-content", v && v), L = window.innerHeight * .1, R = e("scroll-to-top", O > L && "in"), z = A === "application";
	return /* @__PURE__ */ p(i.Fragment, { children: [/* @__PURE__ */ p("div", {
		...D,
		ref: M,
		className: F,
		children: [/* @__PURE__ */ p("div", {
			className: "module-content-wrapper",
			children: [
				S && S,
				x && x,
				z ? /* @__PURE__ */ f(n, {
					ref: j,
					slideIn: !y,
					largeTrack: !0,
					trackOffset: !0,
					className: I,
					onScroll: N,
					children: /* @__PURE__ */ f("div", {
						className: "scrollbar-content",
						children: E
					})
				}) : /* @__PURE__ */ f("div", {
					className: "module-content",
					children: E
				})
			]
		}), b && /* @__PURE__ */ f("span", {
			className: R,
			children: /* @__PURE__ */ f(t, {
				bsStyle: t.PRIMARY,
				iconName: "icon-arrow-up",
				iconOnly: !0,
				"aria-label": "↑",
				onClick: P
			})
		})]
	}), C && C] });
});
//#endregion
export { g as default };

//# sourceMappingURL=ApplicationLayoutBody.js.map